export default __webpack_public_path__ + "static/media/attached.25418c68.svg";